import React, { Component } from 'react';
import { crudActions } from "@sm/services/crudActions";
import Form from "@sm/core/Form";
import { DATA_TYPES } from "@modules/data/ManualInput";

class DebitCreditComponent extends Component {
  state = {
  };

  componentDidMount() {
    const { getOptionsFromState } = this.props;
    if (getOptionsFromState) {
      this.setState({
        getOptionsFromParentState: getOptionsFromState,
      });
    }
  }
  
  onSaveDataEntries = (isApproved) => {
    const { companiesPsps, controls, form, savedData } = this.props;

    form.map(elem => elem.creditAmount = elem.creditAmount ? parseFloat(elem.creditAmount) : elem.creditAmount);
    const isValid = form.map((elem) => elem.isFormValid()).every(Boolean);
    this.saveValidationUpdate(form, isValid, isValid);

    if (isValid) {
      let isSameProvider = true;
      const credits = form.map((credit) => {
        if (credit.creditPsp !== savedData.psp) {
          isSameProvider = false;
        }
        return {
          debitMidId: credit.debitMidId,
          creditMidId: credit.creditMidId,
          value: credit.creditAmount,
        };
      });

      if (!isSameProvider && !isApproved) {
        const providers = companiesPsps[controls.company];
        const debitProvider = providers.find(provider => provider.value === savedData.psp);
        this.updateState({
          showPromptModal: true,
          loadingDataInput: false,
          lockButton: false,
          promptMessage: `Please confirm you have been settled by the ${debitProvider?.label || 'Debit'} Provider before executing this swap.`
        });
        return;
      };

      const data = {
        date: savedData.date,
        clientId: savedData.merchant,
        data: credits
      };

      crudActions.post(`v1/data/input/debit_credit`, data,)
        .then(() => {
          controls.resetValidation(); 
          const newState = {
            showSecondPanel: false,
            showPromptModal: false,
            loadingDataInput: false,
            submitClicked: false,
            promptMessage: "",
            controls
          };
          form.forEach((elem, index) => {
            Object.assign(newState, {
              [`midsForCredit${ index + 1 }`]: []
            });
          });
          this.updateState(newState);
          this.afterSuccessSave("Operation successful.");
        })
        .catch((err) => {
          this.errorUpdate(err?.message);
        });
    }
  };

  onChangeFilter = () => {
    const { controls, companiesPsps } = this.props;

    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);

    if (isFormValid) {
      const data = {
        clientId: controls.merchant,
        providerId: controls.psp,
        currency: controls.currency
      };
      crudActions.post(`v1/mids/balances`, data).then((response) => {
        const filteredMids = this.props.filterMids(controls.psp, controls.merchant, null, controls.currency);
        const midIds = new Set(filteredMids.map(item => item.value));
        const filteredResponse = response.filter(item => midIds.has(item.midId));
        if (filteredResponse.length) {
          const newState = this.populateCreditDebitForm(filteredResponse);
          Object.assign(newState,{
            midsForDebit: filteredMids,
            creditPsps: companiesPsps[controls.company]
          });
          Object.assign(newState, {
            showSecondPanel: true,
            loadingDataInput: false,
            lockButton: false,
          });
          this.updateState(newState);
        } else {
          this.errorUpdate('No available MIDs found.');
          this.updateState({
            showSecondPanel: false
          });
        }
      }).catch((error) => {
        this.errorUpdate(error ? error.message : "");
      });
    }
  };

  populateCreditDebitForm = (response) => {
    let { form, fields } = this.props;
    form = [];
    fields = [];
    const midsWithAvailableBalance = response.filter(elem => elem.balance > 0);
    fields.push([
      { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" },
      { fieldType: "button", noWriteAccess: true }
    ]);
    midsWithAvailableBalance.forEach(elem => { this.onAddDebitCreditItem(fields, form, elem.midId, parseFloat(elem.balance)); });
    if (fields.length === 1) {
      this.onAddDebitCreditItem(fields, form);
    }
    this.updateField(DATA_TYPES.DEBIT_CREDIT, fields);
    const stateForUpdate = {};
    Object.assign(stateForUpdate, {
      debitCreditForm: form
    });
    return stateForUpdate;
  };

  onAddDebitCreditItem = (fields, debitCreditForm, debitMidId, debitBalance) => {
    const length = fields.length;
    if (length > 1) {
      fields[length - 2].forEach(elem => {
        if (elem.name === "deleteRowButton" || elem.name === "addRowButton") {
          elem.empty = true;
        }
      });
    }
    fields.splice(length - 1, 0, this.getDebitCreditMidsRowFields(length));
    debitCreditForm.push(this.getDebitCreditMidsRowForm(debitMidId, debitBalance));
  };

  getDebitCreditMidsRowForm = (debitMidId, debitBalance) => {
    return new Form(
      {
        debitMidId: debitMidId ? debitMidId : "",
        debitBalance: debitBalance ? parseFloat(debitBalance) : "",
        creditMidId: "",
        creditBalance: "",
        creditAmount: "",
        disabled: !debitBalance,
        isChecked: false
      },
      [
        {
          name: "debitMidId",
          type: "isNumber",
          rules: {
            required: true,
            min: 0
          },
        },
        {
          name: "debitBalance",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "creditMidId",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "creditBalance",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "creditAmount",
          type: "isNumber",
          rules: {
            required: true,
          },
        }
      ]
    );
  };

  getDebitCreditMidsRowFields = (length) => {
    return [
      {
        name: "debitMidId",
        label: "Debit Mid",
        fieldType: "select",
        flexGrow: 10,
        getOptions: () => this.state.getOptionsFromParentState("midsForDebit"),
        items: "midsForDebit",
      },
      {
        name: "debitBalance",
        label: "Debit Balance",
        fieldType: "input",
        flexGrow: 10,
        disabled: true,
        inputType: "number"
      },
      {
        name: "creditPsp",
        label: "Provider",
        fieldType: "select",
        flexGrow: 10,
        getOptions: () => this.state.getOptionsFromParentState("creditPsps"),
        items: "creditPsps"
      },
      {
        name: "creditMidId",
        label: "Credit Mid",
        fieldType: "select",
        flexGrow: 10,
        inputType: "number",
        getOptions: () => this.state.getOptionsFromParentState("midsForCredit" + length),
        items: "midsForCredit" + length
      },
      {
        name: "creditBalance",
        label: "Credit Balance",
        fieldType: "input",
        disabled: true,
        flexGrow: 10,
        inputType: "number"
      },
      {
        name: "creditAmount",
        label: "Credit Amount",
        fieldType: "input",
        flexGrow: 10,
      },
      {
        name: "checkBox",
        fieldType: "checkBox",
        autoMethod: (index) => this.props.onAutoFunction(index),
        alignSelf: "end",
        disabled: true,
        flexGrow: 0
      },
      {
        name: "deleteRowButton",
        fieldType: "deleteRowButton",
        columnStyle:  { width: "30px" },
        inputColumn: false,
        notInput: true,
        vertical: "start",
        deleteRow: (index) => this.onDeleteItem(index),
        alignSelf: "center",
        empty: length < 2
      },
      {
        name: "addRowButton",
        fieldType: "addRowButton",
        columnStyle:  { width: "30px" },
        notInput: true,
        vertical: "start",
        addRow: () => this.onAddRow(),
        alignSelf: "center"
      }
    ];
  };

  onAddRow = () => {
    const fields = this.getOptionsFromProps("fields");
    const form = this.getOptionsFromProps("form");
    this.onAddDebitCreditItem(fields, form);
    this.updateField(DATA_TYPES.DEBIT_CREDIT, fields);
    const stateForUpdate = {};
    Object.assign(stateForUpdate, {
      debitCreditForm: form
    });
    this.updateState(stateForUpdate);
  };

  onDeleteItem = () => {
    const { form, fields } = this.props;
    const dynamicKey = `midsForCredit${ form.length }`;
    fields.splice(fields.length - 2, 1);
    const length = fields.length;
    fields[length - 2].forEach(elem => {
      if ((elem.name === "deleteRowButton" && fields.length > 2) || elem.name === "addRowButton") {
        elem.empty = false;
      }
    });
    this.updateField(DATA_TYPES.DEBIT_CREDIT, fields);
    const stateForUpdate = {};
    Object.assign(stateForUpdate, {
      debitCreditForm: form.slice(0, -1),
      [dynamicKey]: []
    });
    this.updateState(stateForUpdate);
  };

  getOptionsFromProps = (optionsName) => {
    return this.props[optionsName];
  };

  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };
  
  saveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = (message) => {
    this.props.updateStateAfterSuccessSave(message);
  };

  errorUpdate = (message) => {
    this.props.showErrorAlert(message);
  };

  render() {
    return <></>;
  };
}

export default DebitCreditComponent;